import { cva } from 'class-variance-authority';
export { default as Button } from './Button.vue';

export const buttonVariants = cva(
  'tw:touch-target tw:inline-flex tw:min-w-0 tw:items-center tw:justify-center tw:gap-2 tw:rounded-full tw:whitespace-normal tw:wrap-anywhere tw:transition-colors tw:disabled:pointer-events-none tw:disabled:opacity-45 tw:disabled:shadow-none tw:[&_svg]:pointer-events-none tw:[&_svg]:shrink-0 tw:shrink-0 tw:focus-visible:ring-3 tw:focus-visible:ring-ring/40 tw:aria-invalid:ring-destructive/20',
  {
    variants: {
      variant: {
        default:
          'tw:bg-primary tw:text-primary-foreground tw:shadow-button tw:hover:bg-primary/90 tw:active:bg-primary/80',
        destructive: 'tw:bg-destructive tw:text-primary-foreground tw:hover:bg-destructive/90',
        'destructive-soft': 'tw:bg-destructive-soft tw:text-destructive tw:hover:bg-destructive/15',
        success:
          'tw:bg-success-button tw:text-primary-foreground tw:shadow-(--shadow-button-success) tw:hover:bg-success-button-hover',
        outline:
          'tw:border-[1.5px] tw:border-button-border tw:bg-card tw:text-foreground tw:hover:bg-accent',
        secondary: 'tw:bg-secondary tw:text-foreground tw:hover:bg-accent',
        close: 'tw:bg-close tw:text-muted-foreground tw:hover:bg-accent',
        info: 'tw:bg-primary tw:text-primary-foreground tw:hover:bg-primary/90',
        'info-toggle':
          'tw:bg-(--info-soft) tw:text-(--info-ink) tw:aria-expanded:bg-primary tw:aria-expanded:text-primary-foreground tw:focus-visible:ring-0 tw:focus-visible:-outline-offset-2 tw:aria-expanded:focus-visible:outline-primary-foreground',
        ghost: 'tw:text-foreground tw:hover:bg-accent',
        link: 'tw:text-link tw:underline-offset-4 tw:hover:underline',
      },
      size: {
        default: 'tw:min-h-[54px] tw:px-[22px] tw:py-[12px] tw:type-button',
        sm: 'tw:min-h-[38px] tw:px-[16px] tw:py-[8px] tw:type-button-small tw:shadow-none',
        lg: 'tw:min-h-[56px] tw:px-[32px] tw:py-[12px] tw:type-button',
        icon: 'tw:size-[var(--icon-control-size)] tw:p-0 tw:type-button',
        'icon-sm': 'tw:size-[var(--icon-small-size)] tw:p-0 tw:type-button',
        'icon-close': 'tw:size-[var(--icon-close-size)] tw:p-0 tw:type-button',
        'icon-xs': 'tw:size-[30px] tw:p-0 tw:type-button',
        'icon-inline': 'tw:size-(--icon-action) tw:p-0 tw:type-button',
      },
    },
    compoundVariants: [
      {
        variant: 'outline',
        size: 'icon',
        class: 'tw:border-border tw:shadow-[var(--shadow-soft)]',
      },
    ],
    defaultVariants: { variant: 'default', size: 'default' },
  },
);
